
export default {
  name: "PricingPlans",
  props: {
    availablePlans: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      billingPeriod: 'monthly',
      currency: 'eur',
    };
  },
  computed: {
    availablePlansPerCurrency() {
      return this.availablePlans.filter((plan) => {
        return (
          (plan.currency.toLowerCase().includes(this.currency) &&
            plan.billingPeriod.toLowerCase().includes(this.billingPeriod)) ||
          plan.id === 'basic'
        )
      })
    },
  },
}
